import React, { FC } from 'react';
import Modal from '@common/modal';

import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './completeModal.module.scss';
const cx = classnames.bind(styles);

interface IConfirmModalProps {
  visible: boolean;
  onClose: () => void;
}

const CompleteModal: FC<IConfirmModalProps> = ({ visible, onClose }) => {
  const onClickBtn = () => {
    onClose();
    V2Route.goMainPage();
  };

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>계정 연동이 완료되었습니다.</strong>

        <p className={cx('desc')}>
          해당 포지션에서 진행되는 모든 전형과 메시지를
          <br />
          잡다에서 손쉽게 확인하고 관리해보세요!
        </p>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'confirm')} role="button" onClick={onClickBtn}>
            확인
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default CompleteModal;
